import { Typography, MenuItem } from '@mui/material'
import StyledBreadcrumbs from 'components/atoms/container/Breadcrumbs'
import { useNavigate, useLocation } from 'react-router-dom'
import { MY_JOURNEY, ASSESSMENTS } from 'routes/constants'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { StyledSelect } from 'components/atoms/input/StyledInputs'
import JumpToGoalButton from 'components/molecules/home/JumpToGoalButton'

const AssessmentHeader = ({ goals, selectedGoal }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const crumbs = []
  if (location.state?.fromMyPath) {
    crumbs.push({
      label: 'My Paths',
      path: MY_JOURNEY,
      state: {
        showMyPath: true
      }
    })
  }
  crumbs.push({
    label: `${selectedGoal.name} - ${t('headers.assessments')}`
  })

  const gotoGoalAssessmentPath = goalId => {
    navigate(`${ASSESSMENTS}/${goalId}`)
  }

  return (
    <ColStack spacing={4}>
      <StyledBreadcrumbs containerSx={{ paddingY: 8 }} crumbs={crumbs} />

      <RowStack justifyContent={'space-between'} alignItems={'flex-start'}>
        <Typography
          variant='h1'
          flex={
            1
          }>{`${selectedGoal.name} ${t('headers.assessments')}`}</Typography>

        <RowStack spacing={8} width='auto' alignItems={'flex-start'}>
          {goals.length > 0 && (
            <StyledSelect
              value={selectedGoal.id}
              onChange={e => {
                gotoGoalAssessmentPath(e.target.value)
              }}
              renderValue={selected => {
                return (
                  <Typography variant='selectionText' noWrap>
                    {goals.find(g => g.id === selected)?.name}
                  </Typography>
                )
              }}
              sx={{
                width: 220,
                '& .MuiSelect-select.MuiSelect-outlined': {
                  paddingRight: 20
                },
                '& .MuiSvgIcon-root': { right: 0 }
              }}>
              {goals
                .filter(g => g.hasAssessment && !g.isLocked)
                .map((goal, index) => (
                  <MenuItem value={goal.id} key={`goal-${index}`}>
                    {goal?.name}
                  </MenuItem>
                ))}
            </StyledSelect>
          )}
          <JumpToGoalButton />
        </RowStack>
      </RowStack>
    </ColStack>
  )
}
export default AssessmentHeader
